<template>
  <section id="footer">
    <div class="container">
<!--      <div class="heading-wrapper">-->
<!--        <h3>下载客户端工具 </h3>-->
<!--        <p>请您根据您的操作系统，选择应用程序。</p>-->
<!--        <a :href="this.common.downHost+'/downloads/Windows/anyconnect-win-4.8.03052-core-vpn-predeploy-k9.msi'" class="primary-btn">Windows</a>-->
<!--        <a :href="this.common.downHost+'downloads/MacOS10.15/anyconnect-macos-4.8.03052-core-vpn-webdeploy-k9.dmg'" class="primary-btn">MacOS（10.15 Catalina版本以上)</a>-->
<!--        <a :href="this.common.downHost+'/downloads/MacOS13-15/anyconnect-macos-4.7.04056-core-vpn-webdeploy-k9.dmg'" class="primary-btn">MacOS（10.13以上、10.15以下)</a>-->
<!--        <br> <a href="https://itunes.apple.com/cn/app/cisco-anyconnect/id1135064690?mt=8" class="primary-btn">IOS（Iphone/Ipad）</a>-->
<!--        <a :href="this.common.downHost+'/downloads/Android/anyconnect20191022.apk'" class="primary-btn">Android （Phone/PAD）</a>-->
<!--      </div>-->
      <div class="row topmargin-lg justify-content-center">
<!--        <div class="col-md-4">-->
<!--          <small><a @click="$router.push({name:'answer'})">关于我们</a></small>-->
<!--          <small><a @click="$router.push({name:'privacy'})">隐私政策</a></small>-->
<!--          <small>© Copyright {{year}} {{this.common.footerLinkStr}}</small>-->
<!--        </div>-->
<!--        <div class="col-md-4" v-if="this.showbeian">-->
<!--          <small><a href="https://beian.miit.gov.cn" target="_blank">{{this.common.beian}}</a></small>-->
<!--        </div>-->
<!--        <div class="col-md-4">-->
<!--          <small>技术支持 <a :href="this.common.homeLink" target="_blank" :title="this.common.name">{{this.common.name}}</a> - Collect from <a :href="this.common.homeLink" :title="this.common.name" target="_blank">{{ this.common.name }}</a></small>-->
<!--        </div>-->


        <div class="col-md-4 footer-us">
          <h6>关于我们</h6>
          <p>火焰云加速器致力于为全球游戏玩家提供最优质的网络加速服务</p>
        </div>

        <div class="col-md-4 footer-us">
          <h6>快速链接</h6>
          <p><a @click="$router.push({name:'downLoad'})">客户端下载</a></p>
          <p><a @click="$router.push({name:'privacy'})">隐私政策</a></p>
        </div>

        <div class="col-md-4 footer-us">
          <h6>联系方式</h6>
          <p><a @click="$router.push({name:'customer'})">邮箱：{{this.common.email}}</a></p>
        </div>

      </div>

      <div class="row topmargin-lg justify-content-center">
        <div class="footer-copyright">
          <p>© Copyright {{year}} {{this.common.footerLinkStr}}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    showbeian: {
      type: Boolean,
      default: false
    }
  },
  name: "footerPage",
  data(){
    return{
      year:'',
    }
  },
  mounted() {
    this.year = new Date().getFullYear()
  }
}
</script>

<style scoped lang="scss">
p, small {
  color: #5b617c;
  font-family: 'Roboto', sans-serif;
}

.heading-wrapper {
  max-width: 850px;
  margin: 0 auto;
  text-align: center;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color: #282c47 !important;
}
/*/////////////////////////////////////////
Footer
////////////////////////////////////////*/
.heading-wrapper p {
  font-size: 20px;
}

.primary-btn {
  background-color: #E74C3C;
  color: #ffffff;
  display: inline-block;
  font-size: 10px;
  margin: 5px;
  padding: 14px 30px;
  border-radius: 4px;
}

.info-btn2 {
  background-color: #28a745;
  color: white !important;
  margin: 5px;
  padding: 0.55rem 0rem;
}
#footer {
  background-color: #282c47;
  text-align: center;
  padding: 80px 0 30px 0;
  small a{
    color: #2d8eff;
  }
}

#footer h6 {
  color: #ffffff!important;
  margin-bottom: 25px;
}

#footer i {
  font-size: 20px;
  color: #5b617c;
  margin: 0 5px;
}

#footer p {
  cursor: pointer;
}


.footer-us {
  text-align: left;
  color: #9CA3AF;

}

.footer-copyright {
  color: #9CA3AF;
  margin-top: 30px;
}

</style>